import { useQuery } from "react-query";
import client from "../../../../../../apollo/apolloClient";
import ApolloWhatsappTemplates from "../../../../../../apollo/apolloWhatsappTemplates";

// The rules that read the rows of this lookup live in a module without Apollo
// imports (so the forms can use them without loading the client); they are
// re-exported here, next to the lookup that feeds them.
export {
  TEMPLATE_NAME_DELETED_LOCK_MS,
  TEMPLATE_NAME_DELETED_MESSAGE,
  classifyTemplateNameMatches,
} from "../../helpers/template-name-availability";

/**
 * Templates of `channelId` named exactly `name`, in any status (the query has
 * no status filter), up to 10 rows so a deleted row cannot hide a live one.
 * Shared by the Campaigns hook below and by the Settings name step, so both
 * ask the backend the same question.
 */
export const fetchTemplatesByName = async (channelId, name) => {
  const response = await client.query({
    query: ApolloWhatsappTemplates.GET_TEMPLATE_BY_NAME_AND_CHANNEL,
    variables: { channelId, name },
    fetchPolicy: "network-only",
  });

  return response.data.whatsappTemplates ?? [];
};

/**
 * Checks if a template with the given `name` already exists in the `channelId`.
 * Only activates when both parameters are valid and have at least 3 chars.
 */
export const useCheckTemplateName = (channelId, name) => {
  return useQuery(
    ["template-name-check", channelId, name],
    () => fetchTemplatesByName(channelId, name),
    {
      enabled: !!channelId && !!name && name.length >= 3,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchInterval: false,
      retry: false,
    },
  );
};
